import { render, staticRenderFns } from "./Exhibitions.vue?vue&type=template&id=c8b78114&scoped=true&"
import script from "./Exhibitions.vue?vue&type=script&lang=js&"
export * from "./Exhibitions.vue?vue&type=script&lang=js&"
import style0 from "./Exhibitions.vue?vue&type=style&index=0&id=c8b78114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b78114",
  null
  
)

export default component.exports